<!-- 教育培训 -->
<template>
  <div class="container">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <main-navigator :currentIndex="currentIndex"></main-navigator>
    <bread><span slot="nav" style="color:#00A0E9" >教育培训</span></bread>
    <section class="main">
      <ul class="item-wrap">
        <router-link :to="'/educationDetail?id='+item.id" v-for="(item,index) in eduList" :key="index">
          <li>
            <span class="title">{{item.company}}</span>
            <span class="address">{{item.address}}</span>
            <span class="time">{{item.date}}</span>
          </li>
        </router-link>
      </ul>
      <ul class="pageNum">
        <li class="active">1</li>
      </ul>
    </section>
  </div>
</template>
<script>
import LoginNavigator from "../components/LoginNavigator";
import LogoHeader from "../components/LogoHeader";
import Bread from "../components/Bread";
import MainNavigator from "../components/MainNavigator";
import qs from "qs";
export default {
  data() {
    return {
      currentIndex: 1,
      pageNum: 0,
      listIndex: 0,
      eduList: [
        [
          {
            title: "广州专业中医艾灸培训班",
            address: "广东",
            time: "201-01-13"
          },
          {
            title: "深圳美容美发培训班",
            address: "广东",
            time: "2017-12-20"
          },
          {
            title: "广州零基础中医推拿培训班",
            address: "广东",
            time: "2017-11-16"
          },
          {
            title: "深圳学化妆,新娘跟妆培训",
            address: "广东",
            time: "2017-10-20"
          },
          {
            title: "深圳西点、蛋糕培训班",
            address: "广东",
            time: "2017-09-26"
          }
        ]
      ]
    };
  },
  components: {
    Bread,
    LoginNavigator,
    LogoHeader,
    MainNavigator
  },
  computed: {},
  created() {
    this.listIndex = parseInt(this.$route.query.id);
  },
  mounted() {
    this.getSecondInfo();
  },
  methods: {
    getSecondInfo: function() {
      var that = this,
        id = that.listIndex;
      var postData = {
        id: id
      };
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getSecondInfo",
          qs.stringify(postData)
        )
        .then(function(res) {
          var list = res.data.info;
          for (var i = 0, len = list.length; i < len; i++) {
            var time;
            var year, month, date, day;
            time = list[i].create_time;
            date = new Date(time);
            year = date.getFullYear();
            month = date.getMonth();
            day = date.getDay();
            list[i].date = year + "-" + month + "-" + day;
          }
          that.eduList = list;
          console.log("list", list);
        });
    }
  }
};
</script>
<style  scoped>
footer {
  height: 100px;
  width: 100%;
  background: #fafafa;
}
.container {
  background-color: #f5f5f5;
}
.main {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 36px;
  background: #fff;
}
.main .item-wrap {
}
.main .item-wrap li {
  padding: 40px;
  border-bottom: 1px solid #f2f4f5;
}
.main .item-wrap li span {
  display: inline-block;
  color: #333;
  font-size: 18px;
}
.main .item-wrap li .title {
  width: 500px;
}
.main .item-wrap li .address {
  width: 450px;
}
.main .pageNum {
  margin-top: 40px;
  text-align: center;
}
.main .pageNum li {
  display: inline-block;
  width: 22px;
  height: 28px;
  background: #e6e6e6;
  color: #666;
  text-align: center;
  line-height: 28px;
  margin-right: 14px;
}
.main .pageNum .active {
  color: #fff;
  background: #00a0e9;
}
.main .pageNum .next {
  display: inline-block;
  width: 68px;
  height: 28px;
  color: #fff;
  background: #00a0e9;
  text-align: center;
  line-height: 28px;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/education.vue